import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Clock, CheckCircle2, AlertTriangle, FolderKanban, Truck } from 'lucide-react';
import { KpiCard } from './KpiCard';

export function DashboardOperaciones({ data }) {
  if (!data) return null;
  return (
    <div className="space-y-6" data-testid="dashboard-operaciones">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        <KpiCard title="OTs en Ejecucion" value={data.ots_ejecucion} icon={Clock} color="text-amber-600" bgColor="bg-amber-50" subtitle={`${data.total_ots} totales`} link="/ordenes-trabajo" />
        <KpiCard title="Completadas" value={data.ots_completadas} icon={CheckCircle2} color="text-green-600" bgColor="bg-green-50" />
        <KpiCard title="Detenidas" value={data.ots_detenidas} icon={AlertTriangle} color="text-red-600" bgColor="bg-red-50" urgent={data.ots_detenidas > 0} />
        <KpiCard title="Proyectos" value={data.proyectos_vigentes} icon={FolderKanban} color="text-blue-600" bgColor="bg-blue-50" subtitle={`${data.total_proyectos} totales`} link="/proyectos" />
      </div>
      {data.recepciones_recientes?.length > 0 && (
        <Card>
          <CardHeader className="pb-2"><CardTitle className="text-sm font-bold flex items-center gap-2"><Truck className="w-4 h-4" /> Recepciones Recientes</CardTitle></CardHeader>
          <CardContent>
            <table className="w-full text-xs">
              <thead><tr className="bg-gray-50 text-left"><th className="px-3 py-2">N Recepcion</th><th className="px-3 py-2">OC</th><th className="px-3 py-2">RUT Proveedor</th><th className="px-3 py-2">Fecha</th></tr></thead>
              <tbody>
                {data.recepciones_recientes.slice(0, 7).map((r, i) => (
                  <tr key={i} className="border-t hover:bg-gray-50"><td className="px-3 py-2 font-mono">{r.numero_recepcion}</td><td className="px-3 py-2">{r.numero_oc || '-'}</td><td className="px-3 py-2 font-mono text-[10px]">{r.rut_proveedor}</td><td className="px-3 py-2 text-gray-500">{r.fecha_recepcion || '-'}</td></tr>
                ))}
              </tbody>
            </table>
          </CardContent>
        </Card>
      )}
    </div>
  );
}
